import React from 'react'

import RatingQuestionsListComponent from '../../components/RatingQuestions/RatingQuestionsList'
import RatingQuestionsEditComponent from '../../components/RatingQuestions/RatingQuestionsEdit'

// Frontend only for now: both screens read from a local mock store rather than
// the dataProvider, so no react-admin List/Edit wrappers are used yet.
export const RatingQuestionsList = (props) => (
  <RatingQuestionsListComponent {...props} />
)

export const RatingQuestionsEdit = (props) => (
  <RatingQuestionsEditComponent {...props} />
)
